import { useEffect } from 'react';
import HeaderOnlyWhite from '../components/HeaderOnlyWhite'
import Footer from '../components/Footer.jsx';
import RightPanelMobile from '../components/RightPanelMobileToIns.jsx';

import '../Assets/css/hoteldetails.css'
import '../Assets/css/extrapagefunc.css'

import  '../Assets/js/extrapagefunc.js'

function About()
{
    // Append CSS -----------------------------------------------------
    useEffect(() =>
    {
      window.CallDefaultFunction("AboutUs");
    }, []);

    // Append Body Element To 'root' -----------------------------------------------------
    return(
      <>
        <div className="basic">

          <HeaderOnlyWhite/>

          <div className="MainContentSection">
            <div className="MainSectionWithoutAnyAdd IgnoreWPercent" style={{maxWidth: "none" }}>
              <div className="BlueTopBigContainer">
                <p className="PaymentSectionHeaderText2 InterBoldTextFont" id='AboutUsHeaderText'>About Us</p>
                <p className="LabelGreyHeaderText InterMediumTextFont" id='AboutUsTopMessageText'>PinginGo. More ping more discount for you</p>
              </div>
            </div>

            <div className="BasicContainerExtraSec BasicBoxShadow BasicRoundRadius MinusMarginDueToBlue">
              <div className="BasicContainerPadding ImageAndParagraphContainer">
                <img src="/Assets/images/Icon/pingingo-icon.svg" className="wrap-image" />
                <p className="SectionHeaderTextIndex InterBoldTextFont" id='AboutPinginGoHeaderText' style={{ marginLeft: "0", width: "100%" }}>About PinginGo</p>

                <p className="LabelGreyHeaderSmallerText2 InterRegularTextFont" id='AboutPinginGoMessageText1'><a className="InterBoldTextFont" href="https://pingingo.com">PinginGo</a> merupakan aplikasi layanan promosi akomodasi yang memberikan kemudahan kepada konsumen untuk memesan kamar secara daring <span className="InterMediumItalicTextFont">(online)</span> ke berbagai hotel yang bekerjasama dengan Pingingo dengan diskon yang menarik.</p>

                <p className="LabelGreyHeaderSmallerText2 InterRegularTextFont" id='AboutPinginGoMessageText2'>PinginGo menerapkan konsep <span className="InterBoldItalicTextFont">group buying promo</span><span className="InterMediumItalicTextFont">(promo jika memesan bersama)</span> dalam artinya mitra hotel akan memberikan diskon yang lebih besar kepada konsumen apabila jumlah pemesan kamar untuk tanggal check-in yang sama dari seluruh pengguna PinginGo mencapai target. Semakin banyak konsumen yang memesan kamar untuk tanggal yang sama pada hotel yang sama, maka promo diskon yang ditawarkan akan semakin besar.</p>

                <p className="LabelGreyHeaderSmallerText2 InterRegularTextFont" id='AboutPinginGoMessageText3'>Pingingo.com merupakan layanan yang diberikan oleh <span className="InterBoldTextFont">PT PINGINGO BAHAGIA INDONESIA</span>, sebuah badan usaha swasta yang didirikan di Indonesia.</p>

                <p className="LabelGreyHeaderSmallerText2 InterRegularTextFont" id='AboutPinginGoMessageText4'>Jika Anda membutuhkan solusi atas kendala dalam mengakses atau menggunakan aplikasi Pingingo, atau ingin memberikan saran atau masukan untuk perbaikan layanan atau mengajukan kerjasama, Anda dapat menghubungi kami:</p>

                <div className="OrangeWarningContainer ExtraPagesWarningContainer BasicRoundRadius" style={{ backgroundColor: "#e9f4fb" }}>
                  <div className="LeftSectionContactWrapper">
                    <img src="/Assets/images/ButtonIcon/location-icon.svg" className="WarningCircleIcon"/>
                    <a className="LabelGreyHeaderSmallerText2 InterRegularTextFont" style={{ margin: "auto 0" }} href="https://maps.app.goo.gl/m5mHVqhM1nR65emk9" target="_blank">Foresta Business Loft Unit 29 - Jalan Raya Grand BSD City Cisauk Kabupaten Tangerang Selatan Banten.</a>
                  </div>

                  <div className="TwoAdditionalInfoContainer">
                    <div className="TwoAdditionalInfoWrapper">
                      <img src="/Assets/images/ButtonIcon/phone-black.svg" className="BasicIconInsideButton2" style={{ marginLeft: 0 }}/>
                      <a className="LabelGreyHeaderSmallerText InterRegularTextFont HyperlinkUnderlineText" href="https://api.whatsapp.com/send?phone=628175750000" target="_blank">+628175750000</a>
                    </div>

                    <div className="TwoAdditionalInfoWrapper">
                      <img src="/Assets/images/ButtonIcon/mail-black.svg" className="BasicIconInsideButton2" style={{ marginLeft: 0 }}/>
                      <a className="LabelGreyHeaderSmallerText InterRegularTextFont HyperlinkUnderlineText" href="mailto:cs@pingingo.com" target="_blank">cs@pingingo.com</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="FilterBlocker" style={{ display: "none" }} id="FilterBlocker"></div>

          <div className="FilterRightPanel" id="FilterRightPanel" style={{backgroundColor:"#FFFFFF", padding:0}}>
            <div className='PaddingBalancedBasic' style={{ width: "auto", height: "fit-content", display: "flex" }}>
                <img src="/Assets/images/ButtonIcon/cancel-x-grey.svg" className="CloseButtonInsidePanel Selectable2" onClick={() => window.ShowFilterMenuLeftClicked()} />
            </div>
            <div>
              <button className="DropDownSelectionContainer PaddingBalancedBasic ColumnGapLong" style={{width:"auto"}}>
                <img className="BasicIconInsideInput" style={{marginLeft:0}} src="/Assets/images/ButtonIcon/home-grey.svg" />
                <p className="SignInTopDropDownText">Daftar Jadi Mitra Sekarang</p>
                <a className="HREFInsideContainer" href="https://listing.pingingo.com/"></a>
              </button>
              <button className="DropDownSelectionContainer PaddingBalancedBasic ColumnGapLong" style={{width:"auto"}}>
                <img className="BasicIconInsideInput" style={{marginLeft:0}} src="/Assets/images/ButtonIcon/pingicon.svg" />
                <p className="SignInTopDropDownText">Perjalanan Saya</p>
                <a className="HREFInsideContainer" href="/myping/id"></a>
              </button>
              <button className="DropDownSelectionContainer PaddingBalancedBasic ColumnGapLong" style={{width:"auto"}}>
                <img className="BasicIconInsideInput" style={{marginLeft:0}} src="/Assets/images/ButtonIcon/ProfileIcon.svg" />
                <p className="SignInTopDropDownText">Profil</p>
                <a className="HREFInsideContainer" href="/myprofile/id"></a>
              </button>
              <button className="DropDownSelectionContainer PaddingBalancedBasic ColumnGapLong" style={{width:"auto"}}>
                <img className="BasicIconInsideInput" style={{marginLeft:0}} src="/Assets/images/ButtonIcon/referralicon.svg" />
                <p className="SignInTopDropDownText">Referral</p>
                <a className="HREFInsideContainer" href="/referral/id"></a>
              </button>
              <button className="DropDownSelectionContainer PaddingBalancedBasic ColumnGapLong" style={{width:"auto"}}>
                <img className="BasicIconInsideInput" style={{marginLeft:0}} src="/Assets/images/ButtonIcon/ticket-voucher.svg" />
                <p className="SignInTopDropDownText">Voucher Saya</p>
                <a className="HREFInsideContainer" href="/vouchermenu/id"></a>
              </button>
              <div className="wrap-collabsible">
                <input id="ToggleLangMobile" className="CollapsibleToggleInput" type="checkbox" style={{display:"none"}} />
                <label htmlFor="ToggleLangMobile" className="DropDownSelectionContainer PaddingBalancedBasic ColumnGapLong" style={{width:"auto"}}>
                  <div className="BasicIconInsideInput" style={{marginLeft:0}}>
                    <div className="UserTopProfileIcon BasicThinGreyBorder Selectable2">
                    <img src="/Assets/images/CountryCode/Indonesia.svg" className="ImageFullCover"/>
                    </div>
                  </div>
                  <p className="SignInTopDropDownText" style={{width:"fit-content"}}>Indonesia</p>
                  <img class="BasicInputFieldChevronIconSearch ChevronforCollapsible" src='/Assets/images/ButtonIcon/chevron-grey.svg'></img>
                </label>
                <div className="collapsible-content">
                  <button className="DropDownSelectionContainer PaddingBalancedBasic ColumnGapBasic" style={{backgroundColor:"#f5f5f5"}}>
                    <img src="/Assets/images/CountryCode/Indonesia.svg" className="BasicIconInsideInput2" style={{height:"fit-content"}}/>
                    <p className="SignInTopDropDownText" style={{color:"#353535"}}>Indonesia</p>
                  </button>
                  <button className="DropDownSelectionContainer PaddingBalancedBasic ColumnGapBasic" style={{backgroundColor:"#f5f5f5"}}>
                    <img src="/Assets/images/CountryCode/UnitedKingdom.svg" className="BasicIconInsideInput2" style={{height:"fit-content"}}/>
                    <p className="SignInTopDropDownText" style={{color:"#353535"}}>English</p>
                  </button>
                </div>
              </div>
              <button className="DropDownSelectionContainer PaddingBalancedBasic ColumnGapLong" style={{width:"auto"}}>
                <img className="BasicIconInsideInput" style={{marginLeft:0}} src="/Assets/images/ButtonIcon/signout.svg" />
                <p className="SignInTopDropDownText">Keluar</p>
              </button>
            </div>
          </div>
        </div>

        <RightPanelMobile/>

        <Footer/>
      </>
    )
}

export default About